/* ===========================================================
   SLAB BILTONG — theme.js
   Handles: mobile nav, cart drawer, add-to-cart, qty, PDP
   variants, sticky ATC, filters, accordions, reveal.
   Works standalone (preview mock cart) and on Shopify
   (uses window.Shopify + /cart.js AJAX when present).
   =========================================================== */
(function(){
  "use strict";
  // Deployed theme sets window.__MAX_SHOPIFY__ = true (see theme.liquid).
  const SHOPIFY = !!window.__MAX_SHOPIFY__;
  const FREE_SHIP = (window.__MAX_FREESHIP__ || 500); // R free-shipping threshold
  const money = c => "R" + (Math.round(c)).toLocaleString("en-ZA");
  const $ = (s,r=document)=>r.querySelector(s);
  const $$ = (s,r=document)=>[...r.querySelectorAll(s)];

  /* ---------- Scroll lock (iOS-safe, ref-counted) ---------- */
  let _scrollY=0,_locks=0;
  function lockScroll(){ if(_locks++===0){ _scrollY=window.scrollY||window.pageYOffset||0;
    const b=document.body.style; b.position="fixed"; b.top=`-${_scrollY}px`; b.left="0"; b.right="0"; b.width="100%"; } }
  function unlockScroll(){ if(_locks>0 && --_locks===0){ const b=document.body.style;
    b.position=""; b.top=""; b.left=""; b.right=""; b.width=""; window.scrollTo(0,_scrollY); } }

  /* ---------- Mobile nav ---------- */
  const mnav = $("#mnav");
  function openNav(){ if(!mnav)return; mnav.classList.add("is-open"); mnav.setAttribute("aria-hidden","false"); lockScroll(); }
  function closeNav(){ if(!mnav||!mnav.classList.contains("is-open"))return; mnav.classList.remove("is-open"); mnav.setAttribute("aria-hidden","true"); unlockScroll(); }
  $("#burger")?.addEventListener("click",openNav);
  $("#mnav-close")?.addEventListener("click",closeNav);
  mnav?.querySelector(".mnav__scrim")?.addEventListener("click",closeNav);
  $$(".mnav__links a, .mnav__card, .mnav__foot .btn").forEach(a=>a.addEventListener("click",closeNav));

  /* ---------- Cart state ---------- */
  const cart = $("#cart");
  let LINES = []; // {id,name,meta,price,qty,img,url}
  function openCart(){ if(!cart)return; cart.classList.add("is-open"); cart.setAttribute("aria-hidden","false"); lockScroll(); }
  function closeCart(){ if(!cart||!cart.classList.contains("is-open"))return; cart.classList.remove("is-open"); cart.setAttribute("aria-hidden","true"); unlockScroll(); }
  $("#cart-open")?.addEventListener("click",e=>{e.preventDefault();openCart();});
  $("#cart-close")?.addEventListener("click",closeCart);
  cart?.querySelector(".cart__scrim")?.addEventListener("click",closeCart);

  function subtotal(){ return LINES.reduce((s,l)=>s+l.price*l.qty,0); }
  function count(){ return LINES.reduce((s,l)=>s+l.qty,0); }

  function renderCart(){
    const c = count(), sub = subtotal();
    $$(".cart-count").forEach(el=>{ el.textContent=c; el.style.display=c?"flex":"none"; });
    const items = $("#cart-items"), foot = $("#cart-foot"), ship = $("#cart-ship");
    if(!items) return;
    if(!LINES.length){
      const shopUrl = window.__MAX_SHOPURL__ || "collection.html";
      items.innerHTML = `<div class="cart__empty"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.4 12.2a1 1 0 0 0 1 .8h9.3a1 1 0 0 0 1-.78L21 8H6"/></svg><p>Your bag's empty.<br>Time to slab up.</p><a href="${shopUrl}" class="btn btn--red" data-close-cart>Shop the range</a></div>`;
      foot.style.display="none"; ship.style.display="none";
      items.querySelector("[data-close-cart]")?.addEventListener("click",closeCart);
      return;
    }
    foot.style.display="block"; ship.style.display="block";
    const remain = Math.max(0, FREE_SHIP - sub);
    ship.innerHTML = remain>0
      ? `You're <b>${money(remain)}</b> from free shipping <div class="cart__bar"><i style="width:${Math.min(100,sub/FREE_SHIP*100)}%"></i></div>`
      : `<b>Free shipping unlocked ✓</b> <div class="cart__bar"><i style="width:100%"></i></div>`;
    items.innerHTML = LINES.map((l,i)=>`
      <div class="citem">
        <div class="citem__img"><img src="${l.img}" alt="${l.name}"></div>
        <div class="citem__info">
          <div class="citem__name">${l.name}</div>
          <div class="citem__meta">${l.meta}</div>
          <div class="citem__row">
            <div class="qty">
              <button aria-label="Decrease" data-dec="${i}">−</button>
              <span>${l.qty}</span>
              <button aria-label="Increase" data-inc="${i}">+</button>
            </div>
            <div class="citem__price">${money(l.price*l.qty)}</div>
          </div>
          <button class="citem__rm" data-rm="${i}">Remove</button>
        </div>
      </div>`).join("");
    $("#cart-sub").textContent = money(sub);
    items.querySelectorAll("[data-inc]").forEach(b=>b.onclick=()=>chgQty(+b.dataset.inc,1));
    items.querySelectorAll("[data-dec]").forEach(b=>b.onclick=()=>chgQty(+b.dataset.dec,-1));
    items.querySelectorAll("[data-rm]").forEach(b=>b.onclick=()=>removeLine(+b.dataset.rm));
  }
  function chgQty(i,d){ const q=Math.max(1,LINES[i].qty+d);
    if(SHOPIFY) scChange(LINES[i].key,q); else { LINES[i].qty=q; renderCart(); } }
  function removeLine(i){ if(SHOPIFY) scChange(LINES[i].key,0); else { LINES.splice(i,1); renderCart(); } }

  /* ---------- Shopify AJAX cart (deployed only) ---------- */
  async function scFetch(){
    try{
      const c = await (await fetch("/cart.js")).json();
      LINES = c.items.map(i=>({ key:i.key, id:i.key, name:i.product_title,
        meta:(i.variant_title&&i.variant_title!=="Default Title")?i.variant_title:"", price:i.final_price/100,
        qty:i.quantity, img:i.image? i.image.replace(/(\.(?:png|jpg|jpeg|webp|gif))(\?.*)?$/i,"_160x$1$2"):(window.__MAX_BOXIMG__||"assets/box-mark.png"), url:i.url }));
      renderCart();
    }catch(e){ /* offline */ }
  }
  async function scAdd(variantId, qty){
    await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({items:[{id:+variantId, quantity:qty}]})});
    await scFetch(); openCart();
  }
  async function scChange(key, qty){
    await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({id:key, quantity:qty})});
    await scFetch();
  }

  /* ---------- Preview (mock) add ---------- */
  function addLine(line){
    const ex = LINES.find(l=>l.id===line.id);
    if(ex) ex.qty += line.qty; else LINES.push(line);
    renderCart(); openCart();
  }

  /* ---------- Add to cart buttons ---------- */
  function bindAdd(root=document){
    $$("[data-add]",root).forEach(btn=>{
      if(btn.__bound) return; btn.__bound=true;
      btn.addEventListener("click",async e=>{
        e.preventDefault();
        const d = btn.dataset;
        const qty = +(d.qty || ($("#pdp-qty")?.textContent) || 1);
        if(SHOPIFY){ if(d.variant) await scAdd(d.variant, qty); }
        else { addLine({ id:d.add, name:d.name, meta:d.meta||"", price:+d.price, qty, img:d.img, url:d.url||"#" }); }
        if(btn.dataset.label!==undefined){ const t=btn.textContent; btn.textContent="Added ✓"; setTimeout(()=>btn.textContent=t,1200); }
      });
    });
  }
  bindAdd();
  if(SHOPIFY) scFetch();

  /* ---------- PDP variant logic ---------- */
  const pdp = $("#pdp");
  if(pdp && pdp.dataset.grade){
    const state = { grade: pdp.dataset.grade || "A-Grade", flavour: pdp.dataset.flavour || "Original", size:"500g slab" };
    const PRICE = { "500g slab":{"A-Grade":299,"Geelvet":349}, "200g mini slab":{"A-Grade":149,"Geelvet":169} };
    const COMPARE = {};
    const PROTEIN = { "A-Grade":{"Original":54,"Chilli":53}, "Geelvet":{"Original":48,"Chilli":47} };
    const IMG = g=>{ const gg=g==="Geelvet"?"gv":"ag"; const f=state.flavour==="Chilli"?"chilli":"original"; const m=state.size==="200g mini slab"?"-mini":""; return `assets/pack-${gg}-${f}${m}.png`; };
    function setActive(group,val){ $$(`[data-opt='${group}']`,pdp).forEach(s=>s.classList.toggle("is-active", s.dataset.val===val)); }
    function refresh(){
      const price = PRICE[state.size][state.grade];
      $("#pdp-price").textContent = money(price);
      const cmp = 0;
      if($("#pdp-compare")) $("#pdp-compare").style.display="none";
      
      $("#pdp-img").src = IMG(state.grade);
      pdp.querySelectorAll("[data-thumb]").forEach(t=>t.querySelector("img").src=IMG(t.dataset.thumb==="gv"?"Geelvet":"A-Grade"));
      const prot = PROTEIN[state.grade][state.flavour];
      $("#pdp-protein") && ($("#pdp-protein").textContent = prot+"g");
      $("#pdp-gradedesc") && ($("#pdp-gradedesc").textContent = state.grade==="Geelvet"?"Fat-marbled · richer, softer":"Lean cut · dense & clean");
      // sync ATC data
      const atc = $$("[data-add]",pdp);
      atc.forEach(b=>{ b.dataset.price=price; b.dataset.name=`SLAB ${state.flavour}`; b.dataset.meta=`${state.grade} · ${state.size}`; b.dataset.img=IMG(state.grade); b.dataset.add=`${state.grade}-${state.flavour}-${state.size}`; });
      $("#sticky-price").textContent = money(price);
      $("#pdp-title").textContent = state.flavour.toUpperCase();
    }
    $$("[data-opt]",pdp).forEach(sw=>sw.addEventListener("click",()=>{
      const g=sw.dataset.opt, v=sw.dataset.val; state[g==="grade"?"grade":g==="flavour"?"flavour":"size"]=v; setActive(g,v); refresh();
    }));
    refresh();
  }
  /* qty stepper (any PDP) */
  $("#pdp-qinc")?.addEventListener("click",()=>{const q=$("#pdp-qty");q.textContent=+q.textContent+1;});
  $("#pdp-qdec")?.addEventListener("click",()=>{const q=$("#pdp-qty");q.textContent=Math.max(1,+q.textContent-1);});
  /* sticky mobile ATC (any PDP) */
  const _anchor=$("#pdp-buybox"), _sticky=$("#sticky-atc");
  if(_anchor && _sticky){
    const io2=new IntersectionObserver(([e])=>{ _sticky.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top<0); },{threshold:0});
    io2.observe(_anchor);
  }

  /* ---------- Collection filters ---------- */
  const coll=$("#coll-grid");
  if(coll){
    $$("[data-filter]").forEach(chip=>chip.addEventListener("click",()=>{
      const grp=chip.dataset.group;
      $$(`[data-group='${grp}']`).forEach(c=>c.classList.toggle("is-active",c===chip));
      const g=$(".chip.is-active[data-group='grade']")?.dataset.filter||"all";
      const f=$(".chip.is-active[data-group='flavour']")?.dataset.filter||"all";
      $$(".pcard",coll).forEach(card=>{
        const okG = g==="all"||card.dataset.grade===g;
        const okF = f==="all"||card.dataset.flavour===f;
        card.style.display = (okG&&okF)?"flex":"none";
      });
    }));
  }

  /* ---------- FAQ ---------- */
  $$(".faq__q").forEach(q=>q.addEventListener("click",()=>{
    const it=q.closest(".faq__item"), a=it.querySelector(".faq__a");
    const open=it.classList.toggle("is-open");
    a.style.maxHeight = open ? a.scrollHeight+"px" : 0;
  }));

  /* ---------- Newsletter (preview) ---------- */
  $$(".news__form, #footer-news").forEach(f=>f.addEventListener("submit",e=>{
    e.preventDefault(); const btn=f.querySelector("button"); if(btn){btn.textContent="You're in ✓";}
  }));

  /* ---------- Reveal on scroll ---------- */
  const io=new IntersectionObserver(es=>es.forEach(en=>{ if(en.isIntersecting){en.target.classList.add("in");io.unobserve(en.target);} }),{threshold:.12});
  $$(".reveal").forEach(el=>io.observe(el));

  /* ---------- Escape closes overlays ---------- */
  document.addEventListener("keydown",e=>{ if(e.key==="Escape"){ closeNav(); closeCart(); } });

  renderCart();
})();
